define('models/Report',[
	'models/Base',
	'models/CancellationRate'
], function(Base, CancellationRate) {
	
	return Base.extend({
		
		getClaimCount: function(params, success, error) {
			return can.ajax({
				type: 'GET',
				url: '/Report/ClaimCount',
				data: params
			}).then(function(data) {
				return new can.Map(data);
			}).then(success, error);
		},
		
		getTimelyFilingCount: function(params, success, error) {
			return can.ajax({
				type: 'GET',
				url: '/Report/TimelyFilingCount',
				data: params
			}).then(function(data) {
				return new can.Map(data);
			}).then(success, error);
		},
		
		getStuckInSuspenseCount: function(params, success, error) {
			return can.ajax({
				type: 'GET',
				url: '/Report/StuckInSuspenseCount',
				data: params
			}).then(function(data) {
				return new can.Map(data)
			}).then(success, error);
		},

		getCancellationRate: function(params, success, error) {
			return can.ajax({
				type: 'GET',
				url: '/Report/CancellationRates',
				data: params
			})
			.then(can.proxy(CancellationRate.model, CancellationRate))
			.then(success, error);
		}

	},{

	});
	
});
